import styled from 'styled-components'

const Container = styled.div<{ $contain?: string; $paddingValue?: string }>`
  @media ${({ theme }) => theme.device.lg} {
    max-width: 100%;
    padding-right: 30px;
    padding-inline-start: 30px;
  }
  @media ${({ theme }) => theme.device.xl} {
    max-width: 1190px;
    padding-right: 25px;
    padding-inline-start: 25px;
  }
  width: 100%;
  margin-inline-end: auto;
  margin-inline-start: auto;
  contain: ${({ $contain }) => ($contain ? $contain : 'none')};

  padding-inline-end: 10px;
  padding-inline-start: 10px;

  @media ${({ theme }) => theme.device.ctTablet} {
    padding-right: 40px;
    padding-inline-start: 40px;
  }
`
export default Container
